
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticProps } from 'next';
import InteriorLanding, { type InteriorLandingProps, } from '@/components/interior-landing/InteriorLanding';
import { STAGING_PAGE } from '@/components/interior-landing/pages';
import { getInteriorPageProps } from '@/components/interior-landing/server';
export default function AiVirtualStagingPage(props: InteriorLandingProps) {
    return <InteriorLanding {...props}/>;
}
const getStaticProps: GetStaticProps<InteriorLandingProps> = async () => ({
    props: await getInteriorPageProps(STAGING_PAGE),
});

    async function __Next_Translate__getStaticProps__1a1296daac3__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-virtual-staging',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1296daac3__ as getStaticProps }
  